import React from 'react'

export default () => (
  <div className="row offshore-notes pt-3">
    <div className="col-md-5">
      <div className="row g-0">
        <div className="col-md-7 me-2">
          <strong>Cutoff Times (PST)</strong>
        </div>
        <div className="col-md-3">
          <span className="cutoff-5pm">5:00 pm</span>
        </div>
      </div>
    </div>
    <div className="col-md-7">
      <div className="row g-0">
        <div className="col-md-5">
          <strong>Transit Time</strong>
        </div>
        <div className="col-md-7">
          1 Business Days
        </div>
        <div className="col-md-5">
          <strong>Shipping Cost</strong>
        </div>
        <div className="col-md-7">
          Already Included
        </div>
      </div>
    </div>
  </div>
)
